import { GridRow } from '@mui/x-data-grid';
import type { PlanOverview } from '@weft/api-definition';
import { usePlansOverviewsWithPageParams } from 'apps/app/src/hooks/requests/use-plans-overview/use-plans-overviews';
import React from 'react';
import { NavLink } from 'react-router-dom';
import type { VyTableMinimalProps } from '../../../../components/new-design/table/vy-table/VyTable';
import { VyTable } from '../../../../components/new-design/table/vy-table/VyTable';
import { getPlansOverviewsColumns } from '../plans-page-consts/plans-columns';

export const PlansOverviewTable: React.FC<VyTableMinimalProps<PlanOverview>> = (props) => {
  const { refetch: refetchPlansOverview } = usePlansOverviewsWithPageParams();

  const columns = getPlansOverviewsColumns(refetchPlansOverview);

  return (
    <VyTable
      columns={columns}
      slots={{
        row: (rowProps) => (
          <NavLink
            onClick={(event: React.MouseEvent<HTMLAnchorElement> & { ignore?: boolean }) => {
              if (event.ignore) {
                event.preventDefault();
              }
            }}
            to={`${rowProps.rowId}`}
          >
            <GridRow {...rowProps} />
          </NavLink>
        ),
      }}
      {...props}
      sx={{
        paddingBottom: '140px',
      }}
      paginationClassName="bottom-9 right-10"
    />
  );
};